module.exports = __webpack_public_path__ + "img/qb-pad.cb6c9661.png";